import React from 'react'
import { Link } from 'react-router-dom';
// Bootstrap
import Accordion from 'react-bootstrap/Accordion';
// import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export const NavAccordion = () => {
  return (
    <>
      <div className={`bg-darkest-gray rounded border-b border-t-2 border-l border-r border-black p-1`}>
        <Link to='/' className='text-light-gray no-underline hover:no-underline hover:text-red'>DM Feed</Link>
      </div>
      <div className={`bg-darkest-gray rounded border-1 border-black p-1`}>
        <Link to='/' className='text-light-gray no-underline hover:no-underline hover:text-red'>Food Journal Stories</Link>
      </div>
      <div className={`bg-darkest-gray rounded border-1 border-black p-1`}>
        <Link to='/' className='text-light-gray no-underline hover:no-underline hover:text-red'>#NATS</Link>
      </div>
      <div className={`bg-darkest-gray rounded border-1 border-black p-1`}>
        <Link to='/' className='text-light-gray no-underline hover:no-underline hover:text-red'>The Book</Link>
      </div>

      <Accordion>
        <div className={`bg-darkest-gray rounded border-1 border-black`}>
          <Accordion.Toggle className='text-left px-1 py-2 w-full text-light-gray hover:text-red' eventKey='0'>
            Topic Discussion
              </Accordion.Toggle>
          <Accordion.Collapse eventKey='0'>
            <div className={`bg-darkest-gray border-t-2 border-black p-2`}>
              <p>DM 10 Principles</p>
              <p>DM Grocery List</p>
              <p>Healthy Flavor Enhancers</p>
              <p>DM Videos</p>
            </div>
          </Accordion.Collapse>
        </div>
        <div className={`bg-darkest-gray rounded border-1 border-black`}>
          <Accordion.Toggle className='text-left px-1 py-2 w-full text-light-gray hover:text-red' eventKey='1'>
            Other
              </Accordion.Toggle>
          <Accordion.Collapse eventKey='1'>
            <div className={`bg-darkest-gray border-t-2 border-black p-2`}>
              <p>Anti-inflammatories</p>
              <p>Gluten</p>
              <p>Dairy</p>
            </div>
          </Accordion.Collapse>
        </div>
        <div className={`bg-darkest-gray rounded border-b-2 border-t border-l border-r border-black`}>
          <Accordion.Toggle className='text-left px-1 py-2 w-full text-light-gray hover:text-red' eventKey='2'>
            Community Content
              </Accordion.Toggle>
          <Accordion.Collapse eventKey='2'>
            <div className={`bg-darkest-gray rounded border-t-2 border-black p-2`}>
              <p>Only-Natural Recipes</p>
              <p>Natural Cooking Videos</p>
              <p>Exercise/Fitness</p>
              <p>Graphics/Art</p>
            </div>
          </Accordion.Collapse>
        </div>
      </Accordion>
    </>
  )
}
